import { createAction } from '@mews/framework/redux';
import {
    AUTHORIZE_PAYMENT_CARD_FAILED,
    AUTHORIZE_PAYMENT_CARD_STARTED,
    AUTHORIZE_PAYMENT_CARD_SUCCEEDED,
} from '../../modules/entities/paymentCardAuthorizations/actionTypes';
import { ApplicationState } from '../../types';

export const authorizePaymentCard =
    ({ enterpriseId, paymentCardId }: $TSFixMe) =>
    (dispatch: $TSFixMe, _getState: () => ApplicationState, { apiService }: $TSFixMe) => {
        dispatch(createAction(AUTHORIZE_PAYMENT_CARD_STARTED, { enterpriseId, paymentCardId }));

        return apiService
            .authorizePaymentCard({ enterpriseId, paymentCardId })
            .then((paymentCardAuthorization: $TSFixMe) => {
                dispatch(createAction(AUTHORIZE_PAYMENT_CARD_SUCCEEDED, paymentCardAuthorization));
                return paymentCardAuthorization;
            })
            .catch((error: $TSFixMe) => {
                dispatch(createAction(AUTHORIZE_PAYMENT_CARD_FAILED, { error, enterpriseId }));
                throw error;
            });
    };
